import React from 'react';

const CircularProgress: React.FC = () => {
  return (
    <div className="spinner-wrapper">
      <div className="progress-container">
        <div className="progress-circle"></div>
      </div>
    </div>
  );
};

export default CircularProgress;